<template>
  <div class="d-flex mt-1 pl-4 pb-0">
    <div class="d-flex align-items-center mr-3 ml-1">
      <VIcon> mdi-account </VIcon>
    </div>
    <div class="d-flex flex-column">
      <div>
        <span class="body-2 textPrimary--text">{{ getFullName }}</span>
      </div>
      <div>
        <span class="body-2 textPrimary--text">{{ getPhoneAndEmail }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PassengerInfo',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  passengerInfo: {
    type: Object,
    required: true,
  },
});

const getFullName = computed(() => `${props.passengerInfo.firstName} ${props.passengerInfo.lastName}`);
const getPhoneAndEmail = computed(() => (props.passengerInfo.email
  ? `${props.passengerInfo.phone}, ${props.passengerInfo.email}`
  : props.passengerInfo.phone));
</script>